<template>
    <div class="my-10">
        <h1 class="font-bold text-2xl">{{ $t('page.selectCategory') }}</h1>
        <div class="mt-5 grid grid-cols-4 gap-4 max-lg:grid-cols-3 max-md:grid-cols-2 max-sm:grid-cols-1">
            <router-link v-for="(cat, idx) in $store.publicationCategories" :key="idx" :to="{ name: $store.userData?.has_business_account ? 'addBusinessPublication' : 'addPublication', params: { id: cat.id }, query: { ...getBusinessAccount } }">
                <div class="h-full flex justify-between items-center shadow-custom rounded-md bg-white p-4 cursor-pointer">
                        <p class="text-main-color font-semibold text-xl	">{{ cat.name }}</p>
                </div>
            </router-link>

        </div>
    </div>
</template>

<script>

export default {
    name: 'selectCategory',
    components: {
        
    },
    data(){
        return {
            loading: false
        }
    },
    methods: {

    },
    computed: {
        getBusinessAccount(){
            return this.$route.query.business_account ? { business_account : this.$route.query.business_account } : {}
        }
    },
    created(){

    }
}

</script>